// extracted by mini-css-extract-plugin
export default {"gameHeader":"_37Ds3cAiZUZ-SWJAQz7piz","global":"_3a-5WRneBKuY4Q4TXT_Wzo","content":"_1B5O2JD4b08qX7nIXPHKuL"};